<template>
    <Form ref="form-address" class="bg-white p-8">
        <div class="w-full xl:w-11/12 m-auto">
            <p class="text-left text-2xl text-sm">Finalisez votre commande</p>

            <p class="text-left text-lg font-bold mt-4 mb-2">Mes coordonnées</p>

            <div class="div-form">
                <InputText v-model="form.email" :required="true" label="Email" name="email" type="email"
                    rules="required|email|max:50" :max="50" :errors="errors" :disabled="true" />
                <InputSelect v-model="form.gender_id" :options="$store.genders" :required="true" label="Civilité"
                    name="gender_id" rules="required" :errors="errors" />
            </div>

            <div class="div-form">
                <InputText v-model="form.last_name" :required="true" label="Nom" name="last_name"
                    rules="required|max:21" :max="21" :errors="errors" />
                <InputText v-model="form.first_name" :required="true" label="Prénom" name="first_name"
                    rules="required|max:16" :max="16" :errors="errors" />
            </div>

            <div class="div-form">
                <InputText v-model="form.birth_at" :required="true" label="Date de naissance" name="birth_at"
                    type="date" rules="required" :errors="errors" />
            </div>

            <p class="text-left text-lg font-bold mt-6 mb-2">Adresse de livraison</p>

            <div class="div-form">
                <InputText v-model="form.address1" :required="true" label="Adresse" name="address1"
                    rules="required|max:32" :max="32" :errors="errors" />
                <InputText v-model="form.address2" label="Complément d'adresse (optionnel)" name="address2"
                    rules="max:32" :max="32" placeholder="Résidence, bâtiment, n° d'appartement, etc."
                    :errors="errors" />
            </div>

            <div class="div-form">
                <InputText v-model="form.postal_code" :required="true" label="Code postal" name="postal_code"
                    rules="required|max:5|min:5" :max="5" :errors="errors" />
                <InputSelect v-model="form.town" :options="towns" :required="true" label="Ville" name="town"
                    rules="required|max:255" :errors="errors" />
            </div>

            <div class="div-form">
                <InputText v-model="form.landline_phone" :required="true" label="Téléphone" name="landline_phone"
                    rules="required|max:13" :max="13" :errors="errors" @keydown.space.prevent />
                <InputText v-model="form.mobile_phone" label="Mobile" name="mobile_phone" rules="max:13" :max="13"
                    :errors="errors" @keydown.space.prevent />
            </div>

            <div class="div-form">
                <InputText v-model="form.additionnal_info" label="Informations complémentaires" name="additionnal_info"
                    rules="max:100" :max="100" as="textarea" class="!w-full" :errors="errors" />
            </div>

            <div class="text-left mt-4 text-grey">
                <span class="text-red font-bold">*</span> champs obligatoires
            </div>

            <!-- Optins -->

            <div>
                J'accepte de recevoir les offres et jeux de vos différentes enseignes :
            </div>

            <div class="div-form flex flex-col ml-6">
                <label>
                    <Field v-model="form.optin_email" name="optin_email" type="checkbox" id="optin_email" :value="true"
                        :unchecked-value="false" />
                    Par email
                </label>
                <ErrorMessage class="errorForm" name="optin_email" />
            </div>

            <div class="div-form flex flex-col ml-6">
                <label>
                    <Field v-model="form.optin_sms" name="optin_sms" type="checkbox" id="optin_sms" :value="true"
                        :unchecked-value="false" />
                    Par sms et automates d'appel
                </label>
                <ErrorMessage class="errorForm" name="optin_sms" />
            </div>

            <div class="div-form flex flex-col">
                <label>
                    <Field v-model="form.optin_partners" name="optin_partners" type="checkbox" id="optin_partners"
                        :value="true" :unchecked-value="false" />
                    J'accepte de recevoir les offres de vos partenaires par email
                </label>
                <ErrorMessage class="errorForm" name="optin_partners" />
            </div>
            <div v-if="this.$store.optinVariant === 'optin'" class="div-form flex flex-col">
                <label>
                    <Field v-model="form.optin_rules" name="optin_rules" type="checkbox" id="optin_rules"
                        rules="required" :value="true" :unchecked-value="false" />
                    Je déclare avoir lu et accepté les
                    <span class="link cursor-pointer underline relative z-10" @click.stop.prevent="
                        openModal(
                            'Conditions Générales de Vente',
                            $template.conditions,
                            $template.conditions_picture
                        )
                        ">conditions générale de ventes</span>
                    et le
                    <span class="link cursor-pointer underline relative z-10" @click.stop.prevent="
                        openModal(
                            'Règlement Officiel de Jeu – Attribution soumise à aléas – À lire avec attention',
                            $template.rules,
                            $template.rules_picture
                        )
                        ">règlement de jeu</span>
                    <span class="text-red font-bold"> * </span>
                </label>
                <ErrorMessage class="errorForm" name="optin_rules">
                    <p class="text-red font-bold text-lg">Veuillez accepter les conditions de ventes et le règlement de
                        jeu pour continuer</p>
                </ErrorMessage>
            </div>

            <div v-if="paypalErrors != ''" class="errorForm mt-2">
                {{ paypalErrors }}
            </div>

            <img src="@/assets/img/accepted-cards.jpg" alt="" class="m-auto mt-4">

            <div class="paypal-container mt-2 relative">
                <div id="paypal-button" class="paypal-button"></div>
                
                <button v-if="$store.optinVariant === 'optin'"
                    class="p-2 rounded-lg w-full min-h-[56px] text-lg font-bold relative z-10 pointer-events-none"
                    :style="{
                        backgroundColor: $template?.button_background_color || 'red',
                        color: $template?.button_text_color || '#ffffff'
                    }"
                    type="button">
                    Je valide ma commande
                </button>
                
                <button v-else
                    class="p-2 py-3 rounded-lg w-full min-h-[56px] flex flex-col items-center justify-center text-lg font-bold relative z-10 pointer-events-none leading-snug"
                    :style="{
                        backgroundColor: $template?.button_background_color || 'red',
                        color: $template?.button_text_color || '#ffffff'
                    }"
                    type="button">
                    <span>Je valide ma commande</span>
                    <span class="mt-3 text-base font-normal">et déclare avoir lu le 
                        <span class="cursor-pointer underline relative z-10 pointer-events-auto" @click.stop.prevent="
                            openModal(
                                'Règlement Officiel de Jeu – Attribution soumise à aléas – À lire avec attention',
                                $template.rules,
                                $template.rules_picture
                            )
                        ">règlement de jeu</span>
                    </span>
                </button>
            </div>
        </div>
    </Form>
</template>

<script>
import InputText from './Inputs/InputText.vue'
import InputSelect from './Inputs/InputSelect.vue'
import { sendAgencyTracking } from '../../services/agencyTracking'
import { Form, Field, ErrorMessage } from 'vee-validate'

export default {
    components: {
        InputText,
        InputSelect,
        ErrorMessage,
        Form,
        Field
    },
    props: {},
    emits: ['openModal', 'openNotification'],
    data: () => ({
        errors: [],
        form: {},
        paypalErrors: '',
        towns: []
    }),
    computed: {
        winnerToken() {
            return this.$store.wheelWinner?.token
        }
    },
    created() {
        // Pré-remplir avec l'email du winner
        this.form = {
            email: this.$store.wheelWinner?.email ?? '',
            gender_id: '',
            last_name: '',
            first_name: '',
            birth_at: '',
            town: '',
            postal_code: '',
            address1: '',
            address2: '',
            landline_phone: '',
            mobile_phone: '',
            additionnal_info: '',
            optin_email: false,
            optin_sms: false,
            optin_partners: false,
            optin_rules: false
        }

        // Charger PayPal
        let clientId = null
        if (window.location.href.includes('localhost') || window.location.href.includes('digiworks')) {
            console.log('PayPal test mode')
            clientId = 'AUzmJMkw_ik0v9qhTt7pVmL9v4nMHD4lfBpQFLbjKBZxTwsl6AY9a5lAar74mxaK-cmK1azaGup16U0M'
        } else {
            clientId = 'AVfXETPnp536qAY_nzldk-MIEqhzFKt8KzAeVn76ladx1mxMJ99UJqwmxbt2Vkjpnxxl0sYKiWvGiod8'
        }

        const script = document.createElement('script')
        script.src = `https://www.paypal.com/sdk/js?client-id=${clientId}&locale=fr_FR&currency=EUR`
        script.addEventListener('load', this.paypalSetLoaded)
        document.body.appendChild(script)
    },
    methods: {
        openModal(title, message, img) {
            this.$emit('openModal', title, message, img)
        },
        paypalSetLoaded() {
            window.paypal
                .Buttons({
                    style: {
                        shape: 'pill',
                        color: 'gold',
                        layout: 'horizontal',
                        label: 'paypal',
                        tagline: false
                    },
                    onClick: this.paypalOnClick,
                    createOrder: this.paypalCreateOrder,
                    onApprove: this.paypalOnApprove,
                    onShippingChange: this.paypalOnShippingChange,
                    onError: this.paypalOnError
                })
                .render('#paypal-button')
        },
        async paypalOnClick(data, actions) {
            const validation = await this.$refs['form-address'].validate()
            if (!validation.valid) {
                return actions.reject()
            }

            // Pour les winners wheel, on convertit le winner en participation
            try {
                const convertData = {
                    ...this.form,
                    optin_variant: this.$store.optinVariant ?? 'button',
                    optin_rules: true,
                    campaign_id: this.$campaign.id,
                    landing_id: this.$store.idLanding,
                    cart: this.$store.cart,
                    code_ids: this.$store.participationCodes?.map(c => c.id) ?? [],
                    ...this.$store.utms
                }

                const res = await this.$api.wheelConvert(this.winnerToken, convertData)

                if (res.status === 422) {
                    this.errors = res.data.errors
                    return actions.reject()
                }

                // Stocker la participation créée
                if (res.data.participation) {
                    this.$store.setParticipation(res.data.participation)
                }
                if (res.data.user) {
                    this.$store.setUser(res.data.user)
                }

                return actions.resolve()
            } catch (e) {
                console.log(e)
                this.$emit(
                    'openNotification',
                    'Une erreur est survenue. Veuillez réessayer.',
                    true
                )
                return actions.reject()
            }
        },
        async paypalCreateOrder(data, actions) {
            try {
                const res = await this.$api.createPaypalTransaction(
                    this.$store.participation.id,
                    { isRecall2: false }
                )
                return res.data.paypal_id
            } catch (e) {
                this.$emit(
                    'openNotification',
                    'Une erreur est survenue lors du traitement de votre commande. Veuillez réessayer ultérieurement.',
                    true
                )
                console.log(e)
            }
        },
        async paypalOnApprove(data, actions) {
            try {
                const res = await this.$api.approvePaypalTransaction(this.$store.participation.id)
                await sendAgencyTracking({
                    isTracking: res.data?.is_tracking,
                    utms: this.$store.utms
                })
                this.$store.setIsPayed(true)

                // Tracking purchase
                if (!window.location.href.includes('localhost') && !window.location.href.includes('digiworks')) {
                    this.$gtm.trackEvent({
                        event: 'purchase',
                        campaignid: this.$campaign.code
                    })
                }

                // Nettoyer les données winner
                this.$store.clearWinnerData()

                this.$router.push({ name: 'end' })
            } catch (e) {
                this.$emit(
                    'openNotification',
                    'Une erreur est survenue lors du traitement de votre paiement. Veuillez vérifier les informations de votre carte et réessayer.',
                    true
                )
                console.log(e)
            }
        },
        paypalOnShippingChange: function () {
            return (data, actions) => {
                if (data.shipping_address.country_code !== 'FR') {
                    return actions.reject()
                }
                return actions.resolve()
            }
        },
        paypalOnError: function () {
            return (err) => {
                console.error(err)
                this.paypalErrors = err
            }
        }
    },
    watch: {
        async 'form.postal_code'(newValue) {
            if (newValue.length == 5) {
                const res = await this.$api.getTowns(newValue)
                if (res.data.length > 0) {
                    this.towns = res.data
                    this.errors = {
                        postal_code: null
                    }
                } else {
                    this.errors = {
                        postal_code: { 0: "Le code postal n'est pas valide." }
                    }
                }
            } else {
                this.errors = {
                    postal_code: null
                }
            }
        }
    }
}
</script>

<style scoped>
.div-form {
    @apply lg:flex w-full mt-3;
}

.input-form {
    @apply lg:w-1/2 lg:mr-4 mt-3 lg:mt-0;
}

.paypal-button {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 1;
    opacity: 0.000001;
}
</style>
